import { Component, HostBinding, Injector, Input } from '@angular/core';
import { CheckBoxGroupItem } from '../../models/checkbox-group-item.model';
import { AbstractValueAccessor, MakeProvider } from '../abstract-value-accessor';

@Component({
  selector: 'app-checkbox-group',
  templateUrl: './checkbox-group.component.html',
  styleUrls: ['./checkbox-group.component.scss'],
  providers: [MakeProvider(CheckboxGroupComponent)]
})
export class CheckboxGroupComponent extends AbstractValueAccessor {
  @Input()
  errorTexts: { [key: string]: string | (() => string) };

  @Input()
  required: boolean;

  @Input()
  label = 'checkBoxGroupLabel';

  @Input()
  index: number;

  @HostBinding('class')
  @Input()
  viewStyle: 'blocks' | 'column' = 'blocks';

  @Input()
  validateOnDirty: boolean;

  @Input()
  checkboxes: CheckBoxGroupItem[];

  constructor(injector: Injector) {
    super(injector);
  }

  groupValueChange(value: { checked: boolean }, item: CheckBoxGroupItem): void {
    const newValue = {};
    const valuesSet = new Set(this.checkboxes.map((checkbox) => checkbox.fieldName));

    if (this.value) {
      Object.keys(this.value).filter((key) => valuesSet.has(key)).forEach((key) => newValue[key] = true);
    }

    if (value.checked) {
      newValue[item.fieldName] = true;
    } else {
      delete newValue[item.fieldName];
    }

    this.value = newValue;
  }

  buildTranslationKey(relativeKey: string): string {
    return `openedPlugin.dynamicForm.${relativeKey}`;
  }
}
